/**
 * Motion columns feature module (W2-04a motion-columns; DESIGN.md §4.5, §4.7, §5.6; ARCHITECTURE.md §7.7;
 * WORKPACKAGES Appendix B: `keys.*` incl. `keys.addAtPlayhead`, `segments.insert|hold|jump|negate|opacity|easing`,
 * `layers.*`, `motion.*`, `columns.focus|pin|compare`).
 *
 * Provides:
 *  - timeline column type "motion" (motionColumns.ts): the collapsed columns of the active line (Guided Position X | Y
 *    pair and kind-specific columns, Full columns per property on the active layer) and pinned columns
 *    (Pin column / Compare lines), instance ids `motion:<line>:<prop>:<layer>` (contracted for W2-04b);
 *  - commands and key bindings for both presets (motionCommands.ts; RPE preset R…R / Q…R segment placement);
 *  - help topics (motion columns, layers, the X/Y link, compare lines);
 *  - `init`: the controller that relayouts and redraws the motion columns as the editor and the document change.
 */

import type { FeatureModule, HelpTopicDef } from '../../app/registry/types';
import { motionController } from './motionColumns';
import { MOTION_COMMANDS, MOTION_KEYBINDINGS } from './motionCommands';
import { m } from './motion.messages';

const HELP: readonly HelpTopicDef[] = [
  {
    id: 'motion.columns',
    title: m.helpColumnsTitle,
    body: m.helpColumnsBody,
    level: 'guided',
    showMe: { helpId: 'motion-columns' },
  },
  { id: 'motion.layers', title: m.helpLayersTitle, body: m.helpLayersBody, level: 'full' },
  { id: 'motion.link', title: m.helpLinkTitle, body: m.helpLinkBody, level: 'guided' },
  { id: 'motion.compare', title: m.helpCompareTitle, body: m.helpCompareBody, level: 'full' },
];

export default {
  id: 'motion',
  commands: MOTION_COMMANDS,
  keybindings: MOTION_KEYBINDINGS,
  timelineColumns: (s) => [motionController(s).def, motionController(s).sparkDef],
  helpTopics: HELP,
  init(s) {
    const c = motionController(s);
    return () => {
      c.dispose();
    };
  },
} satisfies FeatureModule;
